import styled from 'styled-components';

export default styled.h1`
  width: 140px;
  color: #fff;
  font-size: 32px;
  position: absolute;
  top: -16px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
`
